jQuery(document).ready(function($){

	// nascrolluje k hlavnímu receptu na stránce
	$('#jq-scrollto-button').click(function(e){
		e.preventDefault();
		 $('html, body').animate({
			'scrollTop': $('#jq-scrollto-target').offset().top
		}, 400);
	});

});